module.exports = __webpack_public_path__ + "static/media/WeekView.e9958177.svg";